import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PartnersComponent } from "./main/partners/partners.component";
import { ReviewComponent } from "./main/review/review.component";
import { MethodologyComponent } from "./main/methodology/methodology.component";
import { HomeComponent } from "./main/home/home.component";
import { FooterComponent } from "./main/footer/footer.component";
import { HeaderComponent } from "./main/header/header.component";
import { ContactComponent } from "./main/contact/contact.component";
import { CareerComponent } from "./main/career/career.component";
import { FaqComponent } from "./main/faq/faq.component";
import { DisclaimerComponent } from "./main/disclaimer/disclaimer.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BlogComponent } from "./main/blog/blog.component";
import { NgImageSliderModule } from "ng-image-slider";
import {
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
} from "@angular/material";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { MatSnackBarModule } from "@angular/material";
import { MatTabsModule } from "@angular/material";
import { SalesforceComponent } from './main/salesforce/salesforce.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MethodologyComponent,
    PartnersComponent,
    ReviewComponent,
    HeaderComponent,
    FooterComponent,
    CareerComponent,
    ContactComponent,
    FaqComponent,
    DisclaimerComponent,
    BlogComponent,
    SalesforceComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    AppRoutingModule,
    BrowserAnimationsModule,
    NgImageSliderModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatSelectModule,
    MatTabsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
